import styled from "styled-components";

export const DirectoryContainter = styled.div`
  margin: 0 40px;
`;
